<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  [title]="'twoFactorAuthentication' | i18n"
  [subtitle]="data.email"
>
  <!-- disableClose hides the dialog's own close button. Like Cancel, this one waits for 1Password. -->
  <button
    bitDialogHeaderEnd
    type="button"
    bitIconButton="bwi-close"
    buttonType="primaryGhost"
    size="default"
    [label]="'close' | i18n"
    id="onepassword-two-factor-prompt_button_close"
    bitFormButton
    (click)="cancel()"
  ></button>

  <div bitDialogContent>
    <p bitTypography="body1">{{ "enterTheCodeFromYourAuthenticatorApp" | i18n }}</p>
    <bit-form-field disableMargin>
      <bit-label>{{ "verificationCode" | i18n }}</bit-label>
      <input
        bitInput
        type="text"
        id="onepassword-two-factor-prompt_input_code"
        formControlName="code"
        inputmode="numeric"
        autocomplete="one-time-code"
        appAutofocus
        appInputVerbatim
        appInputStripSpaces
      />
    </bit-form-field>
  </div>

  <ng-container bitDialogFooter>
    <button
      bitButton
      buttonType="primary"
      type="submit"
      id="onepassword-two-factor-prompt_button_continue"
      bitFormButton
    >
      <span>{{ "continue" | i18n }}</span>
    </button>
    <button
      bitButton
      buttonType="secondary"
      type="button"
      id="onepassword-two-factor-prompt_button_cancel"
      bitFormButton
      (click)="cancel()"
    >
      <span>{{ "cancel" | i18n }}</span>
    </button>
  </ng-container>
</form>
